import { cn } from '@/lib/utils';
import * as React from 'react';

type InputProps = React.ComponentProps<'input'> & {
  onlyNumbers?: boolean;
  onlyIntegers?: boolean;
};

const Input = ({ className, type, onlyNumbers, onlyIntegers, onInput, ...props }: InputProps) => {
  return (
    <input
      type={type}
      className={cn(
        'flex h-9 w-full font-medium rounded-sm border border-input bg-transparent px-3 py-1 shadow-xs transition-colors file:border-0 file:bg-transparent file:text-sm file:text-foreground placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:bg-surface-subtle disabled:text-muted-foreground disabled:cursor-not-allowed text-control',
        type === 'number' &&
          'appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield]',
        className,
      )}
      onInput={(event) => {
        if (onlyNumbers) {
          event.currentTarget.value = event.currentTarget.value.replace(/[^\d.]/g, '');
        }

        if (onlyIntegers) {
          event.currentTarget.value = event.currentTarget.value.replace(/[^\d]/g, '');
        }

        onInput?.(event);
      }}
      {...props}
    />
  );
};

export { Input };
